// modalSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // You can add specific modal states here
  createProject: false,
  createFolder: false,
  fileUpload: false,
  assignTranslator: false,
  assignValidator: false,
  assignTranslatorAdmin: false,
  viewTranslatorAdmin: false,
  finalCommitConfirm: false,
  // Add more modals as needed
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state[action.payload] = true;
    },
    closeModal: (state, action) => {
      state[action.payload] = false;
    },
    closeAllModals: (state) => {
      // Reset all modal states to false
      Object.keys(state).forEach((key) => {
        state[key] = false;
      });
    },
  },
});

export const { openModal, closeModal, closeAllModals } = modalSlice.actions;

export default modalSlice.reducer;
